<template>
	<div class="pa-5">
		<v-list dense>
			<v-subheader>{{ name }}</v-subheader>
			<v-list-item-group
				v-model="current"
				v-for="(item, i) in items"
				:key="i"
			>
				<folder-list-item
					v-if="item.type == 'folder'"
					:allowUpload="allowUpload"
					:item="item"
					:home="folder"
				></folder-list-item>
				<file-list-item
					v-if="item.type == 'file'"
					:allowUpload="allowUpload"
					:item="item"
					:home="folder"
					@deleted="fileDeleted"
				></file-list-item>
			</v-list-item-group>
		</v-list>

		<upload-field
			label="Upload new document"
			v-if="allowUpload"
			:location="folder"
			:exists="false"
			@complete="newFile"
		></upload-field>
	</div>
</template>
<script>
import Vuex from "vuex";
import { listFiles } from "@/assets/storageFunctions.js";
export default {
	name: "StorageList",
	props: {
		allowUpload: { type: Boolean },
		folder: { type: String },
		upToDate: {type: Boolean },
		folders: { type: [Array, Object], default: () => [] },
		name: { type: String, default: "Documents" },
	},
	data: () => {
		return {
			dialog: false,
			items: [],
			current: false,
			focus: false,
		};
	},
	components: {
		UploadField: () => import("@c/storage/MwUpload"),
		FolderListItem: () => import("@c/storage/FolderListItem"),
		FileListItem: () => import("@c/storage/FileListItem"),
	},
	computed: {
		...Vuex.mapState({
			user: (state) => state.auth.data.id,
		}),
	},
	created() {
		this.getFiles();
	},
	watch: {
		upToDate(v){
			if( !v ) {
				this.getFiles();
			}
		}
	},
	methods: {
		getFiles(){
			const self = this;
			if (!self.folder) {
				return;
			}
			self.items = [];
			listFiles("/" + self.folder).then((a) => {
				a.prefixes.forEach((p) => {
					self.items.push({
						type: "folder", 
						fullPath: p.fullPath,
						name: p.name
					});
				});
				a.items.forEach((i) => {
					i.type = "file";
					self.items.push(i);
				});
					this.$emit("updated");
			});
		},
		newFile(file) {
			let obj = file.ref;
			
			obj.type = "file"
			if (!(this.current && this.current.type == "folder")) {
				this.items.push(obj);
			}
		},
		fileDeleted(item) {
			this.items.splice(this.items.indexOf(item), 1);
		},
	},
};
</script>
